<script>
export default {
    props: {
        topic: {
            type: Object
        }
    },
    data() {
        return {
            optionLabel: ["A", "B", "C", "D"],
        }
    }

}
</script>
<template>
    <div class="options">
        <div class="single-judge" v-if="[1,3].includes(topic.topic_type)">
            <el-radio-group v-model="topic.topic.options.value">
                <el-radio v-for="(item, key) in topic.topic.options.option"
                    :key="key" :label="key">
                    {{ topic.topic_type === 1 ? optionLabel[key]+". "+item.name : item.name }}
                </el-radio>
            </el-radio-group>
        </div>
        <div class="multi-checkbox" v-if="topic.topic_type === 2">
            <el-checkbox-group v-model="topic.topic.options.value">
                <el-checkbox v-for="(item, key) in topic.topic.options.option" :key="key" :label="key">
                    {{ optionLabel[key] + ". " + item.name }}
                </el-checkbox>
            </el-checkbox-group>
        </div>

    </div>
</template>
<style lang="scss" scoped>
.options {
    &, & * {
        box-sizing: border-box;
    }
}
.single-judge {
    &:deep(.el-radio-group) {
        label {
            display: block;
            margin: 10px 0;
        }
    }
}
.multi-checkbox {
    &:deep(.el-checkbox) {
        display: block;
        margin: 10px 0;
    }
}
</style>